import { useSelector } from 'react-redux'

import * as Styled from './styled'
import ActiveAsideOverlay from 'common-components/Overlay'
import { editorSelectors } from 'store/features/editor/selectors'
import { OVERLAY_CONTENT, SUB_SIDEBAR_CONTENT } from './data'

const SubSidebar = () => {
  const overlayType = useSelector(editorSelectors.activeAsideOverlayKey)
  const OverlayComponent = overlayType && OVERLAY_CONTENT[overlayType]

  const activeTab = useSelector(editorSelectors.activeSidebarTab)

  const SubSidebarContent = activeTab ? SUB_SIDEBAR_CONTENT[activeTab] : null

  return (
    <Styled.Container data-role="subsidebar-container">
      {overlayType ? (
        <ActiveAsideOverlay>{OverlayComponent}</ActiveAsideOverlay>
      ) : (
        SubSidebarContent
      )}
    </Styled.Container>
  )
}

export default SubSidebar
